import { gql } from "apollo-boost"

export const GET_IMPLEMENTER_ACCOUNTS = gql`
  query getImplementerAccounts($implementerId: ID!) {
    ImplementerAccounts(implementerId: $implementerId) {
      id
      uid
      email
      roles {
        role
        regions
      }
       assignedSubmissions {
        id
        }
      displayName
      disabled
      implementer {
        id
      }
    }
  }
`
